/**
 * Category Styles for Review UI
 * 
 * Display names and colors for fact categories.
 */

import { ABLE_COLORS } from '../../constants';

export const CATEGORY_STYLES = {
  identity: { label: 'Identity', color: '#8B5CF6' },
  relationships: { label: 'Relationships', color: '#EC4899' },
  projects: { label: 'Projects', color: '#3B82F6' },
  current_work: { label: 'Current Work', color: '#10B981' },
  preferences: { label: 'Preferences', color: '#F59E0B' },
  plans: { label: 'Plans', color: '#6366F1' },
  patterns: { label: 'Patterns', color: '#14B8A6' },
  health: { label: 'Health', color: '#EF4444' },
  dietary: { label: 'Dietary', color: '#22C55E' },
  food_preference: { label: 'Food', color: '#F97316' },
  cooking: { label: 'Cooking', color: '#EA580C' },
  family: { label: 'Family', color: '#A855F7' },
  constraint: { label: 'Constraint', color: '#64748B' },
  pattern: { label: 'Pattern', color: '#0EA5E9' }
};

export function getCategoryStyle(category) {
  const normalized = category?.toLowerCase().replace(/_/g, '_');
  const style = CATEGORY_STYLES[normalized];
  if (!style) return { label: category || 'Other', color: ABLE_COLORS.textMuted };
  return style;
}
